function ReviewIcon(props) {
  return (
    <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.938 25C21.495 25 26 20.495 26 14.937 26 9.38 21.495 4.876 15.937 4.876c-5.557 0-10.062 4.505-10.062 10.063C5.875 20.495 10.38 25 15.938 25zm-2.879-9.169l-2.382-1.925c-.446-.357-.198-1.046.397-1.094l3.101-.214 1.166-2.757c.224-.523.993-.523 1.216 0l1.166 2.757 3.101.214c.571.024.82.737.372 1.094l-2.381 1.925.744 2.9c.149.547-.471.975-.967.69l-2.655-1.57-2.655 1.57c-.496.285-1.116-.143-.967-.69l.744-2.9z"
      />
    </svg>
  )
}

export default ReviewIcon
